import AppSubmitFormSection from "@/apps/list/form-sections/AppSubmitFormSection"
import LegacyAppIconAndTitleFormSection from "@/apps/list/form-sections/LegacyAppIconAndTitleFormSection"
import { useActiveAppModal } from "@/apps/util/activeAppModalContext"
import { ProductAppKind } from "@/apps/util/hooks/__generated__/useAddAppFormStoreMutation.graphql"
import useEditAppFormStore, {
  cleanEditAppFormChangedState,
} from "@/apps/util/hooks/useEditAppFormStore"
import ContentCurriculumTimeEstimateSetting from "@/dashboard/form/ContentCurriculumTimeEstimateSetting"
import { GlobalID } from "@/relay/RelayTypes"
import Form from "@components/form/Form"
import { displayErrorToast, displaySuccessToast } from "@components/toast/ToastProvider"
import { DiscoDivider, DiscoFormControl, DiscoSwitch, DiscoText } from "@disco-ui"
import useFeatureFlags from "@utils/hook/useFeatureFlags"
import { observer } from "mobx-react-lite"

interface Props {
  appId?: GlobalID
  kind: ProductAppKind
}

function GenericAppSettingsModalContent({ appId, kind }: Props) {
  const { closeModal } = useActiveAppModal()
  const form = useEditAppFormStore(appId)
  const { contentTimeToComplete } = useFeatureFlags()

  return (
    <Form
      testid={"AppSettingsModalForm"}
      onSubmit={handleEditApp}
      buttons={
        <AppSubmitFormSection
          form={form}
          mode={"edit"}
          isSubmitDisabled={false}
          onClose={closeModal}
        />
      }
    >
      <LegacyAppIconAndTitleFormSection form={form} />
      {kind === "curriculum" && (
        <div>
          <DiscoDivider />
          <DiscoFormControl marginBottom={3} marginTop={1}>
            <DiscoSwitch
              label={
                <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                  <DiscoText variant={"body-md-600"}>{"Completed Users"}</DiscoText>
                </div>
              }
              sublabel={
                <DiscoText variant={"body-sm"} color={"groovy.neutral.700"}>
                  {"Show name and avatar of Members who complete a Modules."}
                </DiscoText>
              }
              checked={form.state.showCompletedUsers ?? true}
              onChange={(isOn) => {
                form.state.showCompletedUsers = isOn
              }}
              disabled={form.isSubmitting}
            />
          </DiscoFormControl>
          {contentTimeToComplete && <ContentCurriculumTimeEstimateSetting form={form} />}
        </div>
      )}
    </Form>
  )

  async function handleEditApp() {
    try {
      const { didSave } = await form.submit({
        id: form.state.id,
        ...cleanEditAppFormChangedState(form),
        badge: form.state.badge,
      })
      if (!didSave) return
      displaySuccessToast({
        message: "Updated app!",
        testid: "AddApp.success-toast",
      })
      closeModal()
    } catch (error) {
      displayErrorToast(error)
    }
  }
}

export default observer(GenericAppSettingsModalContent)
